import { type IconName, iconNames } from "lucide-react/dynamic";

/** 已注册的 Lucide 动态图标名集合，用于运行时校验 */
const ICON_NAME_SET = new Set<string>(iconNames);

/**
 * PascalCase / camelCase → kebab-case，与 Lucide IconName 对齐
 * @param name 如 Store、BarChart3
 */
export const toLucideIconName = (name: string): string =>
  name
    .replace(/([a-z])([0-9])/g, "$1-$2")
    .replace(/([0-9])([A-Z])/g, "$1-$2")
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1-$2")
    .toLowerCase();

/**
 * 将后端图标名解析为 Lucide 动态图标名
 * @param name 后端配置的图标名字符串
 */
export const resolveLucideIconName = (name?: string | null): IconName | null => {
  if (!name?.trim()) return null;
  const kebab = toLucideIconName(name.trim());
  return ICON_NAME_SET.has(kebab) ? (kebab as IconName) : null;
};
